<template>
  <div v-if="prod != undefined">
    <h5>Product Details</h5>
    <ul>
      <li class="detail-line" v-if="prod.Item_id">
        Item Id :
        <span class="detail-line-txt">{{ prod.Item_id }}</span>
      </li>
      <li class="detail-line" v-if="prod.UoM && prod.UoM != 'pc'">
        Unit of Measure :
        <span class="detail-line-txt">{{ prod.UoM }}</span>
      </li>
      <li class="detail-line" v-if="prod.Size">
        Size :
        <span class="detail-line-txt">{{ prod.Size }}</span>
      </li>
      <li class="detail-line" v-if="prod.Colour">
        Colour :
        <span class="detail-line-txt">{{ prod.Colour }}</span>
      </li>
      <li class="detail-line" v-if="prod.Country">
        Country of Origin :
        <span class="detail-line-txt">{{ prod.Country }}</span>
      </li>
      <li class="detail-line mt-3" v-if="prod.Specs">
        Specs :
        <span class="detail-line-txt" v-html="'<br>'+prod.Specs.replace(/\\n/g, '<br>')"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DetailsSection",
  props: ["prod"],
  mounted() {},
};
</script>

<style>
.detail-line-txt {
  font-weight: 600;
}
</style>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
</style>
